import { ImageComponent } from 'components/Image';
import { MobileAppContext } from 'modules/mobileApp/context';
import { useContext } from 'react';
import { Link } from 'react-navi';
import { getActiveConfigs } from './helpers';

interface IDownloadAndroidAppProps {
  onClick?: () => void;
  width?: number;
  height?: number;
  download?: boolean;
}

export const DownloadAndroidApp = ({
  onClick,
  width,
  height,
  download,
}: IDownloadAndroidAppProps) => {
  const { data } = useContext(MobileAppContext);
  if (!data) return null;

  const configs = getActiveConfigs(data);

  if (!configs.length) return null;

  return (
    <>
      {configs.map((config) => (
        <Link
          className="button"
          href={config.getHref(data, download)}
          key={config.alt}
          onClick={onClick}
        >
          <ImageComponent
            alt={config.alt}
            className="button-download"
            height={height || 48}
            src={config.src}
            width={width || 144}
          />
        </Link>
      ))}
    </>
  );
};
